






import Vue from "vue";
import { NameResourceItem } from "@megarax/client/src/resources/NameResourceItem";

export default Vue.extend({
  components: {},
  props: {
    value: {
      type: NameResourceItem,
      required: true,
    },
  },
});
